<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex xs12 class="px-3 py-0">
        <v-layout row>
          <v-flex
            :xs4="!hasLimitedView()"
            :xs12="hasLimitedView()"
            class="px-2 pb-0"
          >
            <v-card class="px-2" style="height: 384px">
              <v-card-title class="pb-1" primary-title>
                <h3 class="headline my-0">
                  Account ID:
                  {{ accountID }}
                </h3>
              </v-card-title>
              <v-card-text class="mb-2 pb-0 pt-2">
                <h4 class="card-title font-weight-medium mt-2 mb-2">
                  {{ name }}
                </h4>
                <p class="mb-0">
                  {{ hname }}
                </p>
                <div class="ml-2 pl-1 mt-4 pt-2">
                  <v-layout row class="mb-2">
                    <div class="font-weight-medium mr-2">
                      Address:
                    </div>
                    <div>
                      {{ address1 }}
                    </div>
                  </v-layout>
                  <v-layout row class="mb-2">
                    <div class="font-weight-medium mr-2">
                      Email:
                    </div>
                    <div>
                      {{ emailAddress }}
                    </div>
                  </v-layout>
                  <v-layout row class="mb-2">
                    <div class="font-weight-medium mr-2">
                      Father:
                    </div>
                    <div>
                      {{ father }}
                    </div>
                  </v-layout>
                  <v-layout row class="mb-2" v-if="shver">
                    <div class="font-weight-medium mr-2">
                      Shver:
                    </div>
                    <div>
                      {{ shver }}
                    </div>
                  </v-layout>
                </div>
              </v-card-text>
              <div
                style="height: 100px; overflow-y: auto; margin-left: 4px;"
                class="mt-2"
              >
                <v-layout
                  style="width: 250px"
                  row
                  class="my-2 pl-1 ml-2"
                  v-for="phone in phonesNumbers"
                >
                  <div class="font-weight-medium mr-2">
                    {{ getPhoneType(phone.phoneType) }}:
                  </div>
                  <div>
                    {{ phone.phoneNum }}
                  </div>
                </v-layout>
              </div>
              <v-card-actions
                v-if="!hasLimitedView()"
                class="px-3 pb-2"
                style="position: absolute; bottom: 0; right: 0;"
              >
                <a
                  href="#registation"
                  @click.prevent="goToApplicationInfo"
                  style="text-decoration: none; color: #4caf50; font-size: 14px;"
                >
                  Application Info ({{ applicationInfoCount }})
                </a>
              </v-card-actions>
            </v-card>
          </v-flex>
          <v-flex xs4 class="px-2 pb-0" v-if="!hasLimitedView()">
            <v-card style="height: 384px;" class="mb-3">
              <v-card-title class="pb-1" primary-title>
                <h3 class="headline my-0">
                  Balance
                </h3>
              </v-card-title>
              <v-card-text class="pt-3 pb-2">
                <div class="font-weight-medium">
                  Tuition:
                </div>
                <div class="mb-2">
                  {{ tuitionBalance }}
                </div>
                <div class="font-weight-medium">
                  Psichas Habinyonim:
                </div>
                <div class="mb-2">
                  {{ tkhBalance }}
                </div>
                <!-- <div class="font-weight-medium">
                                    Transportation:
                                </div>
                                <div class="mb-2">
                                    {{ transportationBalance }}
                                </div> -->
                <!-- <div class="font-weight-medium">
                                    Total:
                                </div>
                                <div>
                                    {{ totalBalance }}
                                </div> -->
              </v-card-text>
              <v-btn
                small
                outline
                color="success"
                @click="viewBalance"
                class="ml-3"
                >View Balance Details</v-btn
              >
            </v-card>
            <!-- <v-card class="mt-3 pt-3" style="height: 111px">
                            <v-layout
                                row
                                class="mb-1 mx-3 pt-1"
                                v-bind="{ 'pt-3': !busAddress2 }"
                            >
                                <div class="font-weight-medium mr-2">
                                    Geo OK:
                                </div>
                                <div>
                                    {{ geoOK ? "Yes" : "No" }}
                                </div>
                            </v-layout>
                            <v-layout row class="mb-1 mx-3 pt-1">
                                <div class="font-weight-medium mr-2">
                                    Bus Address 1:
                                </div>
                                <div>
                                    {{ busAddress1 }}
                                </div>
                            </v-layout>
                            <v-layout
                                row
                                class="mb-2 mx-3 pt-0"
                                v-if="busAddress2"
                            >
                                <div class="font-weight-medium mr-2">
                                    Bus Address 2:
                                </div>
                                <div>
                                    {{ busAddress2 }}
                                </div>
                            </v-layout>
                        </v-card> -->
          </v-flex>
          <v-flex xs4 class="px-2 pb-0" v-if="!hasLimitedView()">
            <v-card>
              <v-card-title class="pb-1 mb-3" primary-title>
                <h3 class="headline my-0">
                  Website
                </h3>
              </v-card-title>
              <v-card-text class="mb-2">
                <div class="px-3 mt-2">
                  <v-layout row class="mb-2" v-if="lastUpdated">
                    <div class="font-weight-medium mr-2">
                      Last Updated:
                    </div>
                    <div>
                      {{ lastUpdated }}
                    </div>
                  </v-layout>
                  <v-layout row class="mb-2" v-if="lastLoggedIn">
                    <div class="font-weight-medium mr-2">
                      Last Logged In:
                    </div>
                    <div>
                      {{ lastLoggedIn }}
                    </div>
                  </v-layout>
                  <v-layout row wrap class="mb-2">
                    <div class="font-weight-medium mr-2">
                      Account Link (Old Website):
                    </div>
                    <a
                      :href="websiteLink"
                      target="_blank"
                      class="website-link-text"
                      >{{ websiteLink }}</a
                    >
                  </v-layout>
                  <v-layout row wrap class="mb-2">
                    <div class="font-weight-medium mr-2">
                      Account Link:
                    </div>
                    <a
                      style="width: 102%;"
                      :href="newWebsiteLink"
                      target="_blank"
                      class="website-link-text"
                      >{{ newWebsiteLink }}</a
                    >
                  </v-layout>
                  <v-layout row class="mb-2">
                    <div class="font-weight-medium mr-2">
                      Pin:
                    </div>
                    <div>
                      {{ pinNum }}
                    </div>
                  </v-layout>
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs8 class="pt-0">
        <account-transactions
          ref="accountTransactions"
          :transactionsLoaded="transactionsLoaded"
          :allPayments="allPayments"
          :payments="payments"
          :schedules="schedules"
          :transactions="transactions"
          :account="account"
          :reloadPage="reloadPage"
          :scheduleID="scheduleID"
          :paymentMethods="paymentMethods"
          :students="students"
          :tuitionBalance="tuitionBalance"
          :tkhBalance="tkhBalance"
          :transportationBalance="transportationBalance"
          :goToMessageSection="goToMessageSection"
          :goToCallbackSection="goToCallbackSection"
          :goToSiteVisitSection="goToSiteVisitSection"
          :goToIvrCallSection="goToIvrCallSection"
          :goToEmailsSection="goToEmailsSection"
          :callbackRequests="callbackRequests"
          :registrationRequirments="registrationRequirments"
          :contactUsRequests="contactUsRequests"
          :siteVisits="siteVisits"
          :ivrCalls="ivrCalls"
          :loadCallbackRequests="loadCallbackRequests"
          :emails="emails"
          :phonesNumbers="phonesNumbers"
          :geoInfo="geoInfo"
        ></account-transactions>
      </v-flex>
      <v-flex xs4 class="pt-4">
        <!-- <v-card class="pa-2" v-if="!hasLimitedView()">
                    <div class="headline mb-4 mt-2 ml-1">EBT Info</div>
                    <div
                        class="text-success title ml-2"
                        v-if="loadingEbt && !ebtData.length"
                    >
                        Loading...
                    </div>
                    <div v-if="ebtData.length" class="mx-3 mb-3">
                        <v-layout row>
                            <div class="font-weight-medium width-150">
                                Address 1:
                            </div>
                            <div>{{ ebtData[0].address1 }}</div>
                        </v-layout>
                        <v-layout row>
                            <div class="font-weight-medium width-150">
                                Address 2:
                            </div>
                            <div>{{ ebtData[0].address2 }}</div>
                        </v-layout>
                        <v-layout row>
                            <div class="font-weight-medium width-150 mt-2">
                                Children:
                            </div>
                            <div style="white-space: pre-line;">
                                {{ ebtData[0].children }}
                            </div>
                        </v-layout>
                    </div>
                    <div
                        class="title mx-2"
                        v-if="!loadingEbt && !ebtData.length"
                    >
                        No Info
                    </div>
                </v-card> -->
        <!-- <v-card class="pa-2" v-if="!hasLimitedView()">
                    <v-btn
                        class="ml-2"
                        v-if="allowToAddToDistribition"
                        color="success"
                        dark
                        small
                        @click="() => addToDistribition()"
                        >Add To Food Distribition
                    </v-btn>
                </v-card> -->
        <material-card color="green" v-if="!hasLimitedView()">
          <v-flex slot="header">
            <v-layout row>
              <span
                class="subheading font-weight-light mr-3"
                style="align-self: center"
                >Account Settings</span
              >
              <v-spacer></v-spacer>
              <v-btn
                v-if="!settings.editing"
                style="color: #4caf50; background-color: #FFF"
                class="ma-0"
                small
                @click="editSettings()"
                >Edit
              </v-btn>
              <v-btn
                v-if="settings.editing"
                style="color: #999; background-color: #FFF"
                class="my-0 mr-2"
                small
                @click="() => rollbackSettings()"
                >Cancel
              </v-btn>
              <v-btn
                v-if="settings.editing"
                style="color: #4caf50; background-color: #FFF"
                class="ma-0"
                small
                @click="() => saveSettings()"
                >Save
              </v-btn>
            </v-layout>
          </v-flex>
          <v-form>
            <v-container py-0>
              <v-layout wrap>
                <v-flex xs12 class="mt-3 px-0 pb-0">
                  <div v-if="settings.editing">
                    <div v-for="setting in settings.updates">
                      <v-switch
                        v-if="setting.type == 'boolean'"
                        color="success"
                        class="mt-0"
                        v-model="setting.value"
                        :label="setting.name"
                      ></v-switch>
                    </div>
                  </div>
                  <div v-else class="mb-0">
                    <div v-for="(setting, index) in settings.list">
                      <v-layout
                        row
                        class="pr-4 pl-3"
                        v-bind:class="{
                          'mb-4': index + 1 < settings.list.length,
                          'mb-3': index + 1 == settings.list.length,
                        }"
                      >
                        <div class="font-weight-medium">
                          {{ setting.name }}
                        </div>
                        <v-spacer></v-spacer>
                        <div>
                          {{ getSettingValue(setting) }}
                        </div>
                      </v-layout>
                    </div>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </material-card>
        <payment-methods
          v-if="!hasLimitedView()"
          :reloadPage="reloadPage"
          :paymentMethods="paymentMethods"
        >
        </payment-methods>
      </v-flex>
    </v-layout>

    <v-dialog v-model="viewBalanceDialog" max-width="600">
      <v-card class="pa-3">
        <v-card-title class="pl-0 py-0 headline mb-3"
          >Balance Details</v-card-title
        >
        <v-switch
          color="success"
          class="mt-0 text-xs-right"
          @change="loadFurtherBilling"
          label="Show Further Billing"
        ></v-switch>
        <v-layout row class="font-weight-medium">
          <div style="width: 150px;">Date</div>
          <div style="width: 200px;">Description</div>
          <div style="width: 100px;" class="text-xs-right">
            Amount
          </div>
          <div style="width: 100px;" class="text-xs-right">
            Balance
          </div>
        </v-layout>
        <v-divider class="pb-2 mt-0"></v-divider>
        <div style="overflow-y: auto; height: 500px">
          <div v-for="(transaction, index) in balanceDetails">
            <v-layout row class="">
              <div style="width: 150px;">
                {{ transaction.date | date }}
              </div>
              <div style="width: 200px;">
                {{ transaction.description }}
              </div>
              <div
                style="width: 100px;"
                class="text-xs-right font-weight-medium"
                v-if="transaction.txnType == 'D'"
              >
                {{ transaction.amount | currency }}
              </div>
              <div
                style="width: 100px;"
                class="text-xs-right font-weight-medium"
                v-if="transaction.txnType == 'C'"
              >
                ({{ transaction.amount | currency }})
              </div>
              <div style="width: 100px;" class="text-xs-right">
                {{ transaction.balance | currency }}
              </div>
            </v-layout>
            <v-layout
              class="pa-0 ma-0 text-danger"
              v-if="
                transaction.description === 'Scheduled Payment' &&
                  isPastDue(transaction)
              "
              row
            >
              Past Date Payment Not Processed
            </v-layout>
            <v-divider class="pb-2 mt-2"></v-divider>
          </div>
          <div
            v-for="(transaction, index) in futureTransactions"
            v-if="futureTransactions.length"
          >
            <v-layout row class="text-info">
              <div style="width: 150px;">
                {{ transaction.date | date }}
              </div>
              <div style="width: 200px;">
                {{ transaction.description }}
              </div>
              <div
                style="width: 100px;"
                class="text-xs-right font-weight-medium"
                v-if="transaction.type == 'transaction'"
              >
                {{ transaction.amount | currency }}
              </div>
              <div
                style="width: 100px;"
                class="text-xs-right font-weight-medium"
                v-if="transaction.type == 'schedule'"
              >
                ({{ transaction.amount | currency }})
              </div>
              <div style="width: 100px;" class="text-xs-right">
                {{ transaction.balance | currency }}
              </div>
            </v-layout>
            <v-layout
              class="pa-0 ma-0 text-danger"
              v-if="
                transaction.description === 'Scheduled Payment' &&
                  isPastDue(transaction)
              "
              row
            >
              Past Date Payment Not Processed
            </v-layout>
            <v-divider class="pb-2 mt-2"></v-divider>
          </div>
        </div>
        <v-layout
          row
          class="mt-2 mr-3 title text-success"
          justify-space-between
        >
          <div class="font-weight-medium">
            Total
          </div>
          <div class="font-weight-medium text-xs-right mr-0">
            {{ balanceTotal | currency }}
          </div>
        </v-layout>
        <v-card-actions class="mr-0 pb-0 mt-2">
          <v-spacer></v-spacer>
          <v-btn dark color="default" @click="viewBalanceDialog = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card></v-dialog
    >
  </v-container>
</template>
<script>
import moment from "moment";
import accountTransactions from "./Account/AccountTransactions.vue";
import paymentMethods from "./Account/PaymentMethods.vue";
import { formatCurrency, toTitleCase } from "../utils/helpers.js";

export default {
  components: {
    "account-transactions": accountTransactions,
    paymentMethods,
  },
  data: () => ({
    accountID: "",
    name: "",
    hname: "",
    address1: "",
    homePhone: "",
    cellPhone: "",
    emailAddress: "",
    geoOK: "",
    busAddress1: "",
    busAddress2: "",
    websiteLink: "",
    newWebsiteLink: "",

    lastLoggedIn: "",
    lastUpdated: "",
    accountLinkID: "",
    pinNum: "",

    account: {},

    tuitionBalance: "",
    transportationBalance: "",
    tkhBalance: "",
    totalBalance: "",

    scheduleID: null,

    allPayments: [],
    payments: [],
    schedules: [],
    transactions: [],
    balanceDetails: [],
    futureTransactions: [],
    balanceTotal: 0,
    students: [],

    paymentMethods: [],
    callbackRequests: [],
    registrationRequirments: [],
    contactUsRequests: [],
    siteVisits: [],
    ivrCalls: [],
    phonesNumbers: [],
    emails: [],
    ebtData: [],
    loadingEbt: true,

    transactionsLoaded: false,

    allowToAddToDistribition: true,

    goToMessageSection: false,
    goToCallbackSection: false,
    goToSiteVisitSection: false,
    goToIvrCallSection: false,
    goToEmailsSection: false,
    limitedView: false,

    applicationInfoCount: 0,

    viewBalanceDialog: false,

    settings: {
      list: [],
      updates: [],
      editing: false,
    },

    geoInfo: {
      geoOK: "",
      busAddress1: "",
      busAddress2: "",
    },

    cardLastUsed: "",
    father: "",
    shver: "",

    today: new Date(),
  }),
  async created() {
    await this.loadAccount();

    if (this.$route.query.goToMessageSection) {
      this.goToMessageSection = true;
    }
    if (this.$route.query.goToCallbackSection) {
      this.goToCallbackSection = true;
    }
    if (this.$route.query.goToIvrCallSection) {
      this.goToIvrCallSection = true;
    }
    if (this.$route.query.goToSiteVisitSection) {
      this.goToSiteVisitSection = true;
    }
    if (this.$route.query.goToEmailsSection) {
      this.goToEmailsSection = true;
    }

    if (this.$route.query.limitView) {
      this.limitedView = true;
    }

    this.loadAccountSettings();
    this.loadStudents();
    this.loadRegistrationRequirments();
    this.loadCallbackRequests();
    this.loadContactUsRequests();
    this.loadBalanceDetails();
    this.loadEbtData();
    this.loadApplicationInfoCount();
  },
  methods: {
    async loadAccount() {
      const response = await this.$http.get(
        "api/accounts/GetAccoutInfo?accountID=" + this.$route.params.id
      );

      this.fill(response);
    },
    fill(response) {
      const {
        accountID,
        name,
        hname,
        address1,
        homePhone,
        cellPhone,
        lastLoggedIn,
        lastUpdated,
        accountLinkID,
        pinNum,
        emailAddress,
        geoOK,
        father,
        shver,
        busAddress1,
        busAddress2,
      } = response.accountInfo;

      this.accountID = accountID;
      this.name = name;
      this.hname = hname;
      this.address1 = address1;
      this.homePhone = homePhone;
      this.cellPhone = cellPhone;
      this.emailAddress = emailAddress;
      this.account = response.accountInfo;
      this.father = father;
      this.shver = shver;
      this.geoOK = geoOK;
      this.busAddress1 = busAddress1;
      this.busAddress2 = busAddress2;

      this.geoInfo.geoOK = geoOK;
      this.geoInfo.busAddress1 = busAddress1;
      this.geoInfo.busAddress2 = busAddress2;

      this.accountLinkID = accountLinkID;
      this.lastLoggedIn = lastLoggedIn && moment(lastLoggedIn).format("LLL");
      this.lastUpdated = lastUpdated && moment(lastUpdated).format("LLL");
      this.pinNum = pinNum;

      this.websiteLink =
        "https://utaw-old.firebaseapp.com/dashboard/" + accountLinkID;

      this.newWebsiteLink = `https://utaw.web.app/${accountLinkID}/dashboard`;

      this.tuitionBalance = formatCurrency(response.tuitionBalance);
      this.transportationBalance = formatCurrency(
        response.transportationBalance
      );
      this.tkhBalance = formatCurrency(response.tkhBalance);

      this.totalBalance = formatCurrency(
        response.tuitionBalance + response.transportationBalance
      );

      this.transactions = response.transactions;

      this.setupPayments(response);
      this.setupSchedules(response);

      this.expandPaymentDetails();

      this.transactionsLoaded = true;

      this.loadSavedCards();
      this.loadAccountPhones();
      this.loadEmails();
    },
    hasLimitedView() {
      if (this.limitedView) return true;

      const roles = Array.isArray(this.$store.state.authentication.roles)
        ? this.$store.state.authentication.roles
        : this.$store.state.authentication.roles
        ? this.$store.state.authentication.roles.split(",")
        : [];

      return roles.includes("Limited Account View");
    },
    addToDistribition() {
      this.$router.push({
        name: "FoodDistributionAddFamily",
        params: { id: this.accountID },
      });
    },
    async loadSavedCards() {
      const paymentMethods = await this.$http.get(
        "api/payments/getSavedCards?accountID=" + this.accountID
      );

      this.paymentMethods = paymentMethods
        .map((method) => {
          method.cardInfo = method.cardType + " - " + method.cardNumberLast5;

          method.editing = false;
          method.processing = false;

          return method;
        })
        .sort((a, b) => {
          if (Date.parse(a.lastUsed) > Date.parse(b.lastUsed)) return -1;
          if (Date.parse(a.lastUsed) < Date.parse(b.lastUsed)) return 1;
          return 0;
        });
    },
    async loadAccountSettings() {
      const settings = await this.$http.get(
        "api/accounts/getAccountSettings?accountID=" + this.accountID
      );

      this.settings.list = settings;
    },
    async loadAccountPhones() {
      const phones = await this.$http.get(
        "api/accounts/getAccountPhones?accountID=" + this.$route.params.id
      );

      this.phonesNumbers = phones;
    },
    async loadCallbackRequests() {
      const callbackRequests = await this.$http.get(
        "api/broadcast/getCallbackRequests?accountID=" + this.$route.params.id
      );
      this.callbackRequests = callbackRequests.map((c) => {
        c.markAsCompleted = c.status == "COMPLETED";
        c.editing = false;

        return c;
      });
    },
    async loadRegistrationRequirments() {
      const requirments = await this.$http.get(
        "api/accounts/getRegistrationRequirments?accountID=" +
          this.$route.params.id
      );
      this.registrationRequirments = requirments;
    },
    async loadContactUsRequests() {
      const contactUsRequests = await this.$http.get(
        "api/contactus/getForAccount?accountID=" + this.$route.params.id
      );
      this.contactUsRequests = contactUsRequests;
    },
    async loadSiteVisits() {
      const siteVisits = await this.$http.get(
        "api/site/getForAccount?accountID=" + this.$route.params.id
      );
      this.siteVisits = siteVisits;
    },
    async loadEbtData() {
      const ebtData = await this.$http.get(
        "api/accounts/getEbtData?accountID=" + this.$route.params.id
      );
      this.ebtData = ebtData.map((c) => {
        c.children = c.children.replaceAll(", ", "\n");
        return c;
      });
      this.loadingEbt = false;
    },
    async loadIvrCalls() {
      const ivrCalls = await this.$http.get(
        "api/iVRCalls/getForAccount?accountID=" + this.$route.params.id
      );
      this.ivrCalls = ivrCalls;
    },
    async loadStudents() {
      const students = await this.$http.get(
        "api/accounts/getStudents?accountID=" + this.$route.params.id
      );

      this.students = students;
    },
    async loadEmails() {
      const emails = await this.$http.get(
        "api/emails/getForAccount?accountID=" + this.accountID
      );

      this.emails = emails.map((email) => {
        email.showText = false;

        return email;
      });
    },
    async loadBalanceDetails() {
      this.balanceDetails = await this.$http.get(
        "api/accounts/getTransactionDetails?accountID=" + this.accountID
      );

      this.calculateBalance();
    },
    calculateBalance() {
      let totalBalance = 0;
      this.balanceDetails = this.balanceDetails.map((transaction) => {
        let balance = totalBalance;
        if (transaction.description !== "Scheduled Payment") {
          balance =
            totalBalance +
            (transaction.txnType === "D"
              ? transaction.amount
              : -transaction.amount);
        }

        totalBalance = balance;
        transaction = { ...transaction, balance: balance };

        return transaction;
      });

      this.balanceTotal = totalBalance;
    },
    viewBalance() {
      this.viewBalanceDialog = true;
    },
    isPastDue(transaction) {
      return new Date(transaction.date) < this.today;
    },
    async loadFurtherBilling(value) {
      if (!value) {
        this.futureTransactions = [];
        this.calculateBalance();

        return;
      }

      let balanceDetails = await this.$http.get(
        "api/accounts/getFurtherTransactions?accountID=" + this.accountID
      );

      let totalBalance = this.balanceTotal;
      balanceDetails = balanceDetails.map((transaction) => {
        const balance =
          totalBalance +
          (transaction.type === "transaction"
            ? transaction.amount
            : -transaction.amount);

        totalBalance = balance;
        transaction.balance = balance;

        return transaction;
      });

      this.futureTransactions = balanceDetails;
      this.balanceTotal = totalBalance;
    },
    setupPayments(response) {
      const payments = response.payments.map((payment) => {
        payment.date = payment.date;
        payment.selected = false;

        return payment;
      });

      this.payments = payments;
    },
    getPhoneType(phoneType) {
      switch (phoneType) {
        case "PHON":
          return "Home Phone";
        case "CEL":
          return "Cellphone";
        case "MCEL":
          return "Mother Cellphone";
      }
    },
    setupSchedules(response) {
      let schedules = response.schedules.map((schedule) => {
        schedule.dateCreated = schedule.dateCreated;
        schedule.scheduleDetails = [];
        schedule.loading = false;

        return schedule;
      });

      this.schedules = schedules.sort((a, b) => {
        if (Date.parse(a.dateCreated) > Date.parse(b.dateCreated)) return -1;
        if (Date.parse(a.dateCreated) < Date.parse(b.dateCreated)) return 1;
        return 0;
      });
    },
    expandPaymentDetails() {
      if (!this.$route.query.scheduleID) return;

      this.scheduleID = +this.$route.query.scheduleID;
    },
    getSettingValue(setting) {
      if (setting.type != "boolean") return value;

      const value = setting.value.toLowerCase();

      return value == "true" ? "Yes" : "No";
    },
    editSettings() {
      this.settings.editing = true;

      function getSettingValue(setting) {
        if (setting.type != "boolean") return setting.value;

        const value = setting.value.toLowerCase();

        return value == "true";
      }

      this.settings.updates = this.settings.list.map((setting, index) => {
        return {
          value: getSettingValue(setting),
          name: setting.name,
          type: setting.type,
        };
      });
    },
    rollbackSettings() {
      this.settings.editing = false;
    },
    async saveSettings() {
      const settings = this.settings.updates.map((update) => {
        const setting = this.settings.list.find((s) => s.name == update.name);

        setting.value = toTitleCase(update.value.toString());
        setting.userUpdated = this.$store.state.authentication.user;

        return setting;
      });

      try {
        await this.$http.post("api/accounts/saveSettings", settings);
      } finally {
        this.settings.editing = false;
        this.reloadPage();
      }
    },
    async reloadPage() {
      this.processingAction = false;
      this.confirmActionDialog = false;

      await this.loadAccount();
      this.loadAccountSettings();
    },
    async loadApplicationInfoCount() {
      try {
        const response = await this.$http.get(
          "api/newfamilyapplications/GetApplicationByAccountID?accountid=" +
            this.$route.params.id
        );

        if (response) {
          // Match SQL logic from CROSS APPLY FieldsFilled
          const fields = [
            response.landlord,
            response.workPlaceOrBoss,
            response.workBoss,
            response.workAddress,
            response.workPhone,
            response.workType,
            response.note,
            response.workPosition,
            response.yearsInPosition,
            response.shabbatSynagogue,
            response.weekdaySynagogue,
            response.isSatmarMember,
            response.dayan,
            response.inCaseOfEmergencyName,
            response.inCaseOfEmergencyPhone,
            response.foodStampCase,
            response.fatherSchool,
            response.fatherYeshivahKetana,
            response.fatherYeshivahGedolah,
            response.motherSchool,
            response.motherGraduatedYear,
            response.kidsAtHome,
            response.kidsInOtherSchool,
            response.otherSchool,
            response.fatherCity,
            response.wifeWorkPlaceOrBoss,
            response.wifeWorkBoss,
            response.wifeWorkAddress,
            response.wifeWorkPhone,
            response.wifeWorkType,
            response.wifeWorkPosition,
            response.wifeYearsInPosition,
            response.landlordPhone,
            response.vouchers,
            response.playGroup,
          ];

          this.applicationInfoCount = fields.filter((val) => {
            if (val === null || val === undefined) return false;
            const strVal = String(val).trim();
            return strVal !== "" && strVal !== "0";
          }).length;
        } else {
          this.applicationInfoCount = 0;
        }
      } catch (e) {
        console.error("Failed to load application info count", e);
        this.applicationInfoCount = 0;
      }
    },
    goToApplicationInfo() {
      // Use $refs to access the child component and change its tab
      if (this.$refs.accountTransactions) {
        this.$refs.accountTransactions.mainTab = "registation";
        this.$refs.accountTransactions.activeTab = "registation";
      }
    },
  },
};
</script>
<style>
.v-expansion-panel__header {
  height: 63px;
}
.website-link-text {
  color: rgb(32, 166, 237);
  display: inline-block;
  word-wrap: break-word;
  width: 100%;
}
</style>
